import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: '変化し続ける市場の最先端を走るために必須なDX推進を支援',
  title1: '変化し続ける市場の最先端を走るために必須なDX推進を支援',
  introduction_text:
    '株式会社カネカ様とアイスリーデザインは、2019年から「Performance Fibers Solutions Vehicle（PFSV）」事業部のDX推進でパートナーシップを結んでいます。多くの大企業が直面するスピード向上やトップ層とミドル層の意識ギャップについて、執行役員 PFSV事業部長の丸山竜一氏に、カネカ様がどのように変革に取り組んできたかを取材しました。',
  company: '株式会社カネカ',
  tag1text: '新規事業プロジェクト実行支援',
  tag1src: '/cases/business-startup-support/',
  industryTagText: 'メーカー/製造/建設',
  industryTagSrc: '/cases/manufacturing/',
  color: '#222',
  background: '#F8F8F8',
  staff1: '執行役員 PFSV事業部長 丸山竜一さん',
  staff2: '',
  image: '/images/img/cases/kaneka/top.png',
  alt: '変化し続ける市場の最先端を走るために必須なDX推進を支援',
  imgClass: 'fv_img_adjust2',
  noProtrude: true,
}

// プロジェクト概要
export const overviewTitle = '大企業のDX推進における伴走型ご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '株式会社カネカ様とアイスリーデザインは、「Performance Fibers Solutions Vehicle（PFSV）」事業部におけるDX推進のパートナーとして2019年から共にプロジェクトを進めています。日本を代表する総合化学メーカーであり、主力商品であるアクリル系合成繊維「カネカロン」を軸としたビジネスを展開するPFSV事業部は、近年DX推進を急速に進めております。',
  },
  {
    text: '多くの大企業が直面している企業全体としてのスピードをどう上げていくか、さらに、トップ層とミドル層の間にある意識のギャップについて、同社の執行役員にしてPFSV事業部長の丸山竜一氏へお話を伺いました。世界に名だたる大企業であるカネカ様が過去どのように道を切り開き、あらゆる局面での変化が加速している現在どのようにDXに向き合い、変革に取り組んできたのかを取材しました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'グローバル市場の拡張',
        text: 'アフリカ市場への進出とその市場での製品認知と受け入れの拡大。',
      },
      {
        title: 'DX推進の実装',
        text: '新型コロナウイルスの影響により、デジタル化の必要性が急速に高まり、事業のデジタルトランスフォーメーションが急務となった。',
      },
      {
        title: 'オンラインでのビジネス環境適応',
        text: '物理的な接触を避ける必要が出てきたため、オンラインでの事業運営と顧客とのコミュニケーション手法を強化する必要が生じた。',
      },
    ],
    solutions: [
      {
        title: '戦略的な市場調査とパートナーシップ構築',
        text: 'カネカのアフリカ市場進出に際し、アフリカ市場の特性を理解し、適切なマーケティング戦略を設計。現地のパートナーとの協力を通じて、文化的差異を乗り越える。',
      },
      {
        title: 'デジタルトランスフォーメーションの推進',
        text: 'コロナウイルスのパンデミックに対応して、デジタルツールとプラットフォームを活用した事業モデルへの転換を支援。',
      },
      {
        title: 'デジタルコミュニケーションの促進',
        text: 'オンラインでの顧客対応とビジネスプロセスのデジタル化を推進し、非接触でも効果的な顧客エンゲージメントを実現するためのシステムとインフラを構築。',
      },
    ],
  },
]


// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
